const styles = (theme) => ({
  root: {
    paddingBottom: theme.spacing.unit * 2.5,
    [theme.breakpoints.up('md')]: {
      paddingTop: theme.spacing.unit * 1.75,
    },
    [theme.breakpoints.up('lg')]: {
      paddingTop: 0,
      paddingBottom: 0,
    },
  },
  negativeTopMargin: {
    // Use negative margin to counter-act the displacement caused by the avatar
    [theme.breakpoints.up('md')]: {
      marginTop: '-30px',
    },
  },
  avatar: {
    backgroundColor: theme.palette.custom.maintenance,
    marginTop: '0px',
    [theme.breakpoints.up('md')]: {
      marginTop: '10px',
    },
  },
  body: {
    paddingTop: theme.spacing.unit * 2,
    '& a': {
      color: theme.palette.primary.dark,
      textDecoration: 'none',
    },
  },
  buttonCreate: {
    fontSize: '1.125rem',
    fontFamily: 'Calibre',
    color: theme.palette.text.dark,
    padding: 0,
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  buttonInner: {
    marginLeft: theme.spacing.unit,
  },
  dialogTitle: {
    fontSize: '1.3125rem',
    textAlign: 'left',
  },
  dialogContent: {
    textAlign: 'left',
  },
  dialogText: {
    marginTop: theme.spacing.unit,
    whiteSpace: 'pre-wrap',
    lineHeight: 1.6125,
    textAlign: 'left',
  },
  bottomDialogText: {
    marginTop: 0,
    fontSize: '1.125rem',
  },
  dialogButton: {
    marginTop: theme.spacing.unit * 2,
    marginBottom: theme.spacing.unit * 4,
  },
  examples: {
    fontWeight: 600,
  },
  dialogDivider1: {
    marginTop: theme.spacing.unit * 2,
    marginBottom: theme.spacing.unit * 2,
  },
  dialogDivider2: {
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit * 2,
  },
  dialogExpansionPanel: {
    marginTop: `-${theme.spacing.unit}px`,
  },
  dialogList: {
    listStyleType: 'disc',
    padding: 0,
    margin: `-${theme.spacing.unit * 1.5}px 0 -${theme.spacing.unit * 2}px -${
      theme.spacing.unit * 0.5
    }px`,
    '& li': {
      display: 'list-item',
      padding: `${theme.spacing.unit * 0.5}px 0`,
      '& div': {
        padding: 0,
      },
    },
  },
  sectionWithIcon: {
    display: 'flex',
  },
  sectionIcon: {
    border: `1px solid ${theme.palette.border.lighter}`,
    borderStyle: 'solid',
    borderWidth: '1px',
    borderRadius: '100px',
    marginTop: theme.spacing.unit,
    marginRight: theme.spacing.unit * 2,
    padding: 6,
    fontSize: '2.5rem',
    color: theme.palette.primary.dark,
  },
  expandIcon: {
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
      color: theme.palette.text.white,
      borderRadius: '5px',
    },
  },
});

export default styles;
